import render from './render'

export default {
  name: 'Arrow',

  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  },

  render
}
